import { render, staticRenderFns } from "./activitycategorydetails.vue?vue&type=template&id=3aa8f830&scoped=true"
import script from "./activitycategorydetails.vue?vue&type=script&lang=js"
export * from "./activitycategorydetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa8f830",
  null
  
)

export default component.exports